import { AfterViewInit, Component, ElementRef, EventEmitter, NgZone, Output, ViewChild } from '@angular/core';
import { environment } from '../../../environments/environment';

declare global {
  interface Window {
    google?: any;
  }
}

const SCRIPT_SRC = 'https://accounts.google.com/gsi/client';
let scriptPromise: Promise<void> | null = null;

function loadScript(): Promise<void> {
  if (window.google && window.google.accounts) {
    return Promise.resolve();
  }
  if (!scriptPromise) {
    scriptPromise = new Promise<void>((resolve, reject) => {
      const script = document.createElement('script');
      script.src = SCRIPT_SRC;
      script.async = true;
      script.onload = () => resolve();
      script.onerror = () => {
        scriptPromise = null;
        reject(new Error('Google script failed'));
      };
      document.head.appendChild(script);
    });
  }
  return scriptPromise;
}

// "Sign in with Google" (Google Identity Services). Emits the ID token
// (credential) that the master checks with GOOGLE_CLIENT_ID.
@Component({
    selector: 'app-google-button',
    template: `<div #host class="google-button"></div>
      @if (failed) {
        <p class="small text-muted">Não foi possível carregar o login com Google. Use e-mail e senha.</p>
      }`,
    styles: [`.google-button { display: flex; justify-content: center; min-height: 44px; }`],
    standalone: false
})
export class GoogleButtonComponent implements AfterViewInit {
  @Output() credential = new EventEmitter<string>();
  @ViewChild('host') host!: ElementRef<HTMLDivElement>;
  failed = false;

  constructor(private zone: NgZone) { }

  ngAfterViewInit(): void {
    if (!environment.google_client_id) {
      this.failed = true;
      return;
    }
    loadScript().then(() => {
      window.google.accounts.id.initialize({
        client_id: environment.google_client_id,
        callback: (response: { credential: string }) => this.zone.run(() => this.credential.emit(response.credential)),
        ux_mode: 'popup'
      });
      window.google.accounts.id.renderButton(this.host.nativeElement, {
        theme: 'outline', size: 'large', text: 'continue_with', shape: 'pill', locale: 'pt-BR', width: 300
      });
    }).catch(() => this.zone.run(() => this.failed = true));
  }
}
